import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {DocumentId} from "common/types/document";
import {ClausePreview, OtherDocumentClause} from "common/types/clause_preview";
import clausePreviewKey from "../utils/clause_preview_key";

interface ClausePreviewsResponse {
  document_name: string;
  previews: Array<{
    section_reference?: string;
    clause_reference?: string;
    text: string | null;
  }>;
}

export interface ClausePreviewsFetchRequest {
  keys: string[];
}

export interface ClausePreviewsFetchResult {
  entries: Array<{key: string; preview: ClausePreview}>;
}

function toRequest(
  organisationId: OrganisationId,
  projectId: ProjectId,
  documentId: DocumentId,
  clauses: OtherDocumentClause[],
): ClausePreviewsFetchRequest {
  return {keys: clauses.map(clausePreviewKey)};
}

// All clauses must belong to documentId
export default function fetchClausePreviews(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLAUSE_PREVIEWS_FETCH,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      documentId: DocumentId,
      clauses: OtherDocumentClause[],
    ) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/document/${documentId}` +
            "/clause-previews",
          {
            clauses: clauses.map(clause => ({
              section_reference: clause.section_reference,
              clause_reference: clause.clause_reference,
            })),
          },
          {withCredentials: true},
        )
        .then(
          (response: {
            data: ClausePreviewsResponse;
          }): ClausePreviewsFetchResult => ({
            entries: response.data.previews.map((preview, index) => ({
              key: clausePreviewKey(clauses[index]),
              preview: {
                document_name: response.data.document_name,
                text: preview.text,
              },
            })),
          }),
        ),
    toRequest,
  );
}
